export function TouchStart(e, i, cardState, setCardState, setAnswers) {
    setCardState({
        ...cardState,
        index: i,
        targetCard: e.target,
    });

    setAnswers((prevState) => {
        const newState = prevState.map((card, id) => {
            const left =
                id === i
                    ? `${
                          e.targetTouches[0].pageX -
                          window.innerWidth * 0.03 -
                          e.target.clientWidth / 2
                      }px`
                    : card.current.left;
            const top =
                id === i
                    ? `${
                          e.targetTouches[0].pageY -
                          window.innerHeight * 0.15 +
                          20 -
                          e.target.offsetParent.clientHeight / 2
                      }px`
                    : card.current.top;

            return {
                ...card,
                current: {
                    left: left,
                    top: top,
                },
            };
        });
        return newState;
    });
}

export function TouchEnd(e, i, targetArr, setAnswers) {
    const minX = e.target.offsetParent.offsetLeft - e.target.clientWidth;
    const maxX = e.target.offsetParent.offsetLeft + e.target.clientWidth;

    const minY = e.target.offsetParent.offsetTop - e.target.clientHeight * 2;
    const maxY = e.target.offsetParent.offsetTop + e.target.clientHeight * 2;
    let index = 0;

    for (let el of targetArr.current.children) {
        index === i &&
            setAnswers((prevState) => {
                const newState = prevState.map((card, id) => {
                    let left;
                    let top;
                    let isDropped;
                    let target;

                    if (id === i) {
                        if (
                            minX < el.offsetLeft &&
                            el.offsetLeft < maxX &&
                            minY < el.offsetTop &&
                            el.offsetTop < maxY
                        ) {
                            left = el.offsetLeft;
                            top = el.offsetTop;
                            isDropped = true;
                            target = index + 1;
                        } else {
                            left = '';
                            top = '';
                            isDropped = false;
                            target = 0;
                        }
                    } else {
                        left = card.current.left;
                        top = card.current.top;
                        isDropped = card.isDropped;
                        target = card.target;
                    }

                    return {
                        ...card,
                        current: {
                            left: left,
                            top: top,
                        },
                        isDropped: isDropped,
                        target: target,
                    };
                });
                return newState;
            });
        if (index === i) {
            break;
        }

        index += 1;
    }
}
